 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		69: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		69: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors","1":"viz","2":"layouts__BasicLayout","3":"layouts__UserLayout","4":"p__404","5":"p__Account__Settings__Info","6":"p__Account__Settings__models__geographic.js","7":"p__AverageDashboard__Index","8":"p__AverageDashboard__models__activities.js","9":"p__AverageDashboard__models__chart.js","10":"p__AverageDashboard__models__dataExport.js","11":"p__AverageDashboard__models__monitor.js","12":"p__BatchDashboard__Index","13":"p__BatchDashboard__models__batchChart.js","14":"p__BatchDashboard__models__batches.js","15":"p__Dashboard__Index","16":"p__Dashboard__models__activities.js","17":"p__Dashboard__models__chart.js","18":"p__Dashboard__models__dataExport.js","19":"p__Dashboard__models__monitor.js","20":"p__DowntimeLog__Index","21":"p__Exception__404","22":"p__Exception__500","23":"p__Exception__TriggerException","24":"p__Exception__models__error.js","25":"p__Home__Index","26":"p__Integrations__Index","27":"p__Integrations__models__integrations.js","28":"p__Leaderboard__Index","29":"p__LineLevelBoard__Index","30":"p__LineLevelBoard__models__activities.js","31":"p__LineLevelBoard__models__chart.js","32":"p__LineLevelBoard__models__dataExport.js","33":"p__LineLevelBoard__models__monitor.js","34":"p__LinePerformanceMonitor__Index","35":"p__LinePerformanceMonitor__models__activities.js","36":"p__LinePerformanceMonitor__models__chart.js","37":"p__LinePerformanceMonitor__models__dataExport.js","38":"p__LinePerformanceMonitor__models__monitor.js","39":"p__LineSettings__DailyTargets","40":"p__LineSettings__ForceStop","41":"p__LineSettings__HeadCount","42":"p__LineSettings__Index","43":"p__LineSettings__Line","44":"p__LineSettings__PlannedDowntimes","45":"p__LineSettings__Products","46":"p__LineSettings__Shifts","47":"p__LineSettings__StopTime","48":"p__LineSettings__WeeklySchedule","49":"p__LineSettings__WeeklyTargets","50":"p__LineSettings__formulaCreation","51":"p__LineSettings__manualEntry","52":"p__Logs__Index","53":"p__MergeDashboard__index","54":"p__MergeDashboard__models__graph.js","55":"p__Observer__Index","56":"p__Observer__models__batchesForOperator.js","57":"p__PlantSettings__Alerts","58":"p__PlantSettings__Index","59":"p__PlantSettings__Roles","60":"p__PlantSettings__SiteChampion","61":"p__PlantSettings__Users","62":"p__PlantSettings__models__dataExport.js","63":"p__PmaintanenceKpis__Index","64":"p__User__Callback","65":"p__User__Login","66":"p__User__Register","67":"p__User__RegisterResult","68":"p__User__models__register.js"}[chunkId]||chunkId) + ".async.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1,"2":1,"3":1,"5":1,"12":1,"15":1,"20":1,"23":1,"26":1,"28":1,"29":1,"34":1,"52":1,"53":1,"55":1,"63":1,"65":1,"66":1,"67":1,"70":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"vendors","1":"viz","2":"layouts__BasicLayout","3":"layouts__UserLayout","4":"p__404","5":"p__Account__Settings__Info","6":"p__Account__Settings__models__geographic.js","7":"p__AverageDashboard__Index","8":"p__AverageDashboard__models__activities.js","9":"p__AverageDashboard__models__chart.js","10":"p__AverageDashboard__models__dataExport.js","11":"p__AverageDashboard__models__monitor.js","12":"p__BatchDashboard__Index","13":"p__BatchDashboard__models__batchChart.js","14":"p__BatchDashboard__models__batches.js","15":"p__Dashboard__Index","16":"p__Dashboard__models__activities.js","17":"p__Dashboard__models__chart.js","18":"p__Dashboard__models__dataExport.js","19":"p__Dashboard__models__monitor.js","20":"p__DowntimeLog__Index","21":"p__Exception__404","22":"p__Exception__500","23":"p__Exception__TriggerException","24":"p__Exception__models__error.js","25":"p__Home__Index","26":"p__Integrations__Index","27":"p__Integrations__models__integrations.js","28":"p__Leaderboard__Index","29":"p__LineLevelBoard__Index","30":"p__LineLevelBoard__models__activities.js","31":"p__LineLevelBoard__models__chart.js","32":"p__LineLevelBoard__models__dataExport.js","33":"p__LineLevelBoard__models__monitor.js","34":"p__LinePerformanceMonitor__Index","35":"p__LinePerformanceMonitor__models__activities.js","36":"p__LinePerformanceMonitor__models__chart.js","37":"p__LinePerformanceMonitor__models__dataExport.js","38":"p__LinePerformanceMonitor__models__monitor.js","39":"p__LineSettings__DailyTargets","40":"p__LineSettings__ForceStop","41":"p__LineSettings__HeadCount","42":"p__LineSettings__Index","43":"p__LineSettings__Line","44":"p__LineSettings__PlannedDowntimes","45":"p__LineSettings__Products","46":"p__LineSettings__Shifts","47":"p__LineSettings__StopTime","48":"p__LineSettings__WeeklySchedule","49":"p__LineSettings__WeeklyTargets","50":"p__LineSettings__formulaCreation","51":"p__LineSettings__manualEntry","52":"p__Logs__Index","53":"p__MergeDashboard__index","54":"p__MergeDashboard__models__graph.js","55":"p__Observer__Index","56":"p__Observer__models__batchesForOperator.js","57":"p__PlantSettings__Alerts","58":"p__PlantSettings__Index","59":"p__PlantSettings__Roles","60":"p__PlantSettings__SiteChampion","61":"p__PlantSettings__Users","62":"p__PlantSettings__models__dataExport.js","63":"p__PmaintanenceKpis__Index","64":"p__User__Callback","65":"p__User__Login","66":"p__User__Register","67":"p__User__RegisterResult","68":"p__User__models__register.js"}[chunkId]||chunkId) + ".chunk.css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 1);
